import React from 'react';
import { CheckIcon } from 'lucide-react';
type StepIndicatorProps = {
  current: 1 | 2;
  onBack: () => void;
};
const steps = [{
  number: 1,
  label: 'Choose a credit report'
}, {
  number: 2,
  label: 'Review & push liabilities'
}];
export function StepIndicator({
  current,
  onBack
}: StepIndicatorProps) {
  return <nav aria-label="Progress" className="mx-auto w-full max-w-6xl px-6 pb-1 pt-6" data-id="element-98" data-mp="n2reatdebyai">
      <ol className="flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-99" data-mp="9bm818fiw7r7">
        {steps.map((step, index) => {
        const isDone = current > step.number;
        const isActive = current === step.number;
        return <li key={step.number} className="flex items-center gap-3" data-id="element-100" data-mp="3vlfakmfsq6en" data-mpi={index}>
              <button type="button" onClick={isDone ? onBack : undefined} disabled={!isDone} aria-current={isActive ? 'step' : undefined} className={`flex items-center gap-2 rounded-md py-1 text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 ${isDone ? 'cursor-pointer text-brand-600 hover:text-brand-700' : 'cursor-default'} ${isActive ? 'font-semibold text-ink-900' : 'text-ink-500'}`} data-id="element-101" data-mp="4e2vccyh431d">
                <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold leading-none ${isDone || isActive ? 'bg-brand-500 text-white' : 'bg-ink-100 text-ink-500'}`} data-id="element-102" data-mp="6pg2linx5d4m">
                  {isDone ? <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-103" data-mp="3k5nikr5scq83" /> : step.number}
                </span>
                {step.label}
              </button>
              {index < steps.length - 1 && <span className="h-px w-8 bg-ink-300" aria-hidden="true" data-id="element-104" data-mp="3h6f8kbmk2dbs" />}
            </li>;
      })}
      </ol>
    </nav>;
}